import { combineReducers } from "redux";
import restaurant from "./restaurant";
import cart from "./cart";
import user from "./user";
import table from './table';

export default combineReducers({ restaurant, cart, user, table });
